import {
  getAll,
  searchByName,
  getPage,
  getDetail,
  deleteObj,
  querySingleVehicleInfo,
  sendSingleDlysjgParamCmd,
  sendSingleGdDlysjgOffline,
  syncJt808TerminalNum,
  sendToGdDlysjgOffline,
  queryVehicleInfos,
} from '@/api/gddlysjgvehicledataserv'

export default {
  state: {
    state_GdDlysjgVehicleData_GetAllResult: null,
    state_GdDlysjgVehicleData_SearchByNameResult: null,
    state_GdDlysjgVehicleData_GetPageResult: null,
    state_GdDlysjgVehicleData_GetDetailResult: null,
    state_GdDlysjgVehicleData_DeleteObjResult: null,
    state_GdDlysjgVehicleData_QuerySingleVehicleInfoResult: null,
    state_GdDlysjgVehicleData_SendSingleDlysjgParamCmdResult: null,
    state_GdDlysjgVehicleData_SendSingleGdDlysjgOfflineResult: null,
    state_GdDlysjgVehicleData_SyncJt808TerminalNumResult: null,
    state_GdDlysjgVehicleData_SendToGdDlysjgOfflineResult: null,
    state_GdDlysjgVehicleData_QueryVehicleInfosResult: null,
  },
  mutations: {
    SET_GDDLYSJGVEHICLEDATA_GETALL_RESULT: (state, rst) => {
      state.state_GdDlysjgVehicleData_GetAllResult = rst;
    },
    SET_GDDLYSJGVEHICLEDATA_SEARCHBYNAME_RESULT: (state, rst) => {
      state.state_GdDlysjgVehicleData_SearchByNameResult = rst;
    },
    SET_GDDLYSJGVEHICLEDATA_GETPAGE_RESULT: (state, rst) => {
      state.state_GdDlysjgVehicleData_GetPageResult = rst;
    },
    SET_GDDLYSJGVEHICLEDATA_GETDETAIL_RESULT: (state, rst) => {
      state.state_GdDlysjgVehicleData_GetDetailResult = rst;
    },
    SET_GDDLYSJGVEHICLEDATA_DELETEOBJ_RESULT: (state, rst) => {
      state.state_GdDlysjgVehicleData_DeleteObjResult = rst;
    },
    SET_GDDLYSJGVEHICLEDATA_QUERYSINGLEVEHICLEINFO_RESULT: (state, rst) => {
      state.state_GdDlysjgVehicleData_QuerySingleVehicleInfoResult = rst;
    },
    SET_GDDLYSJGVEHICLEDATA_SENDSINGLEDLYSJGPARAMCMD_RESULT: (state, rst) => {
      state.state_GdDlysjgVehicleData_SendSingleDlysjgParamCmdResult = rst;
    },
    SET_GDDLYSJGVEHICLEDATA_SENDSINGLEGDDLYSJGOFFLINE_RESULT: (state, rst) => {
      state.state_GdDlysjgVehicleData_SendSingleGdDlysjgOfflineResult = rst;
    },
    SET_GDDLYSJGVEHICLEDATA_SYNCJT808TERMINALNUM_RESULT: (state, rst) => {
      state.state_GdDlysjgVehicleData_SyncJt808TerminalNumResult = rst;
    },
    SET_GDDLYSJGVEHICLEDATA_SENDTOGDDLYSJGOFFLINE_RESULT: (state, rst) => {
      state.state_GdDlysjgVehicleData_SendToGdDlysjgOfflineResult = rst;
    },
    SET_GDDLYSJGVEHICLEDATA_QUERYVEHICLEINFOS_RESULT: (state, rst) => {
      state.state_GdDlysjgVehicleData_QueryVehicleInfosResult = rst;
    },
  },
  actions: {
    GdDlysjgVehicleDataServ_GetAll({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getAll(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_GDDLYSJGVEHICLEDATA_GETALL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_GDDLYSJGVEHICLEDATA_GETALL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    GdDlysjgVehicleDataServ_SearchByName({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        searchByName(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_GDDLYSJGVEHICLEDATA_SEARCHBYNAME_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_GDDLYSJGVEHICLEDATA_SEARCHBYNAME_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    GdDlysjgVehicleDataServ_GetPage({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getPage(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_GDDLYSJGVEHICLEDATA_GETPAGE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_GDDLYSJGVEHICLEDATA_GETPAGE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    GdDlysjgVehicleDataServ_GetDetail({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getDetail(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_GDDLYSJGVEHICLEDATA_GETDETAIL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_GDDLYSJGVEHICLEDATA_GETDETAIL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    GdDlysjgVehicleDataServ_DeleteObj({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        deleteObj(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_GDDLYSJGVEHICLEDATA_DELETEOBJ_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_GDDLYSJGVEHICLEDATA_DELETEOBJ_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    GdDlysjgVehicleDataServ_QuerySingleVehicleInfo({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        querySingleVehicleInfo(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_GDDLYSJGVEHICLEDATA_QUERYSINGLEVEHICLEINFO_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_GDDLYSJGVEHICLEDATA_QUERYSINGLEVEHICLEINFO_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    GdDlysjgVehicleDataServ_SendSingleDlysjgParamCmd({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        sendSingleDlysjgParamCmd(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_GDDLYSJGVEHICLEDATA_SENDSINGLEDLYSJGPARAMCMD_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_GDDLYSJGVEHICLEDATA_SENDSINGLEDLYSJGPARAMCMD_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    GdDlysjgVehicleDataServ_SendSingleGdDlysjgOffline({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        sendSingleGdDlysjgOffline(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_GDDLYSJGVEHICLEDATA_SENDSINGLEGDDLYSJGOFFLINE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_GDDLYSJGVEHICLEDATA_SENDSINGLEGDDLYSJGOFFLINE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    GdDlysjgVehicleDataServ_SyncJt808TerminalNum({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        syncJt808TerminalNum(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_GDDLYSJGVEHICLEDATA_SYNCJT808TERMINALNUM_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_GDDLYSJGVEHICLEDATA_SYNCJT808TERMINALNUM_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    GdDlysjgVehicleDataServ_SendToGdDlysjgOffline({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        sendToGdDlysjgOffline(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_GDDLYSJGVEHICLEDATA_SENDTOGDDLYSJGOFFLINE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_GDDLYSJGVEHICLEDATA_SENDTOGDDLYSJGOFFLINE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    GdDlysjgVehicleDataServ_QueryVehicleInfos({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        queryVehicleInfos(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_GDDLYSJGVEHICLEDATA_QUERYVEHICLEINFOS_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_GDDLYSJGVEHICLEDATA_QUERYVEHICLEINFOS_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
  },
  getters:{
    get_GdDlysjgVehicleData_GetAllResult: state => {
      return state.state_GdDlysjgVehicleData_GetAllResult;
    },
    get_GdDlysjgVehicleData_SearchByNameResult: state => {
      return state.state_GdDlysjgVehicleData_SearchByNameResult;
    },
    get_GdDlysjgVehicleData_GetPageResult: state => {
      return state.state_GdDlysjgVehicleData_GetPageResult;
    },
    get_GdDlysjgVehicleData_GetDetailResult: state => {
      return state.state_GdDlysjgVehicleData_GetDetailResult;
    },
    get_GdDlysjgVehicleData_DeleteObjResult: state => {
      return state.state_GdDlysjgVehicleData_DeleteObjResult;
    },
    get_GdDlysjgVehicleData_QuerySingleVehicleInfoResult: state => {
      return state.state_GdDlysjgVehicleData_QuerySingleVehicleInfoResult;
    },
    get_GdDlysjgVehicleData_SendSingleDlysjgParamCmdResult: state => {
      return state.state_GdDlysjgVehicleData_SendSingleDlysjgParamCmdResult;
    },
    get_GdDlysjgVehicleData_SendSingleGdDlysjgOfflineResult: state => {
      return state.state_GdDlysjgVehicleData_SendSingleGdDlysjgOfflineResult;
    },
    get_GdDlysjgVehicleData_SyncJt808TerminalNumResult: state => {
      return state.state_GdDlysjgVehicleData_SyncJt808TerminalNumResult;
    },
    get_GdDlysjgVehicleData_SendToGdDlysjgOfflineResult: state => {
      return state.state_GdDlysjgVehicleData_SendToGdDlysjgOfflineResult;
    },
    get_GdDlysjgVehicleData_QueryVehicleInfosResult: state => {
      return state.state_GdDlysjgVehicleData_QueryVehicleInfosResult;
    },
  }
}